import { Link } from '@tanstack/react-router';

const PLANS_SEARCH = {
  status: undefined,
  credits_added: undefined,
  plan_name: undefined,
  tab: undefined,
} as const;

/** The way to Plans. */
export function UpgradeLink() {
  return (
    <Link
      to='/plans'
      search={PLANS_SEARCH}
      className='font-medium text-foreground hover:underline'
    >
      Upgrade
    </Link>
  );
}

/** Not on the plan: its state and the way to Plans. */
export function PlanLocked() {
  return (
    <p
      data-testid='send-mailbox-email-locked'
      className='flex items-center gap-2 text-[12px] text-muted-foreground'
    >
      <span>Not on your plan</span>
      <UpgradeLink />
    </p>
  );
}
